<template>
  <div class="item-concent">
    <div class="item-info">
      <div>
        <img :src="item.image" class="item-img" alt="商品图片" @click="goto">
      </div>
      <div>
        <div class="item-name" @click="goto">{{ item.commonName }}</div>
        <div class="item-norm">{{ item.standard }}</div>
        <div class="item-manufacturer">{{ item.manufacturer }}</div>
        <div class="flex">
          <span class="item-price">{{ item.showPrice }}</span>
          <span class="item-shop">{{ item.shopName }}</span>
        </div>
      </div>
    </div>
    <div>
      <span class="item-count">
        <span class="add" @click="cutdown(item.num)">-</span>
        <input v-model="item.num" class="num">
        <span class="add" @click="add(item.num)">+</span>
      </span>
      <span class="to-cart">
        <b-button class="to-cart-button" variant="danger" @click="addToCart(item)">加入购物车</b-button>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  methods: {
    goto () {
      this.$store.commit('addVisitedItem', this.item.id)
      this.$router.push({ path: '/item', query: { id: this.item.id }})
    },
    addToCart (item) {
      console.log('item++++++', item)
      if (item.price <= 0) {
        this.$emit('showMsg', '价格为0不能添加到购物车')
        return
      }
      if (item.num !== 0) {
        if (this.$store.getters.getItemById(item.id)[0] !== undefined && this.$store.getters.getItemById(item.id)[0].num > 0) {
          item.num = this.$store.getters.getItemById(item.id)[0].num + item.num
        }
        const tmpItem = {};
        ({ id: tmpItem.id, num: tmpItem.num, image: tmpItem.image, shopId: tmpItem.shopId, shopName: tmpItem.shopName,
          standard: tmpItem.norm, commonName: tmpItem.name, manufacturer: tmpItem.manufacture, showPrice: tmpItem.price } = item)
        item.num = 0
        this.$store.commit('addTocart', tmpItem)
        this.$emit('successtocart')
      }
    },
    add (num) {
      this.item.num++
    },
    cutdown (num) {
      if (this.item.num !== 0) {
        this.item.num--
      }
    }
  }
}
</script>
<style scoped>
  .item-img{
    cursor: pointer;
    margin-left: 8px;
    margin-top: 8px;
    display: inline-block;
    width: 100px;
    height: 100px;
  }
  .item-concent{
    margin-top: 20px;
    width: 270px;
    height: 160px;
    background-color: #ffffff;
  }
  .item-info{
    padding: 0px;
    display: flex
  }
  .item-name{
    cursor: pointer;
    margin-left: 5px;
    text-align: left;
    font-size: 18px;
    overflow: hidden;
    display:-webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:1;
    font-weight: 600;
  }
  .item-manufacturer{
    height: 40px;
    margin-left: 5px;
    width: 150px;
    text-align: left;
    font-size: 14px;
  }
  .item-norm{
    margin-left: 5px;
    text-align: left;
    font-size: 14px;
  }
  .item-shop{
   margin-right: 0px;
    margin-top: 0px;
    display:inline-block;
    text-align: left;
    width: 80px;
    font-size: 11px;
    color: #acd7f8;
  }
  .item-price{
    line-height: 20px;
    margin-left: 5px;
    display: inline-block;
    text-align: left;
    font-size: 18px;
    color:#fe4b47
  }
  .flex{
    display:flex;
    justify-content:space-between
  }
 .add {
   cursor:pointer;
    text-align: center;
    width: 30px;
    height: 30px;
    font-size: 30px;
    font-weight: 500;
    color: #000000;
    display: inline-block;
    border: 1px solid #ccc;
    line-height: 25px;
  }
  .num {
  position: relative;
    width: 59px;
    left: 0px;
    top: -4px;
    text-align: center;
    height: 30px;
    border: 1px solid #ccc;
  }
  .item-count{
    display: inline-block;
    margin-left: -30px;
  }
  .to-cart-button{
    top: -5px;
    left: 20px;
    position: relative;
    font-size:10px;
    width: 90px;
    height: 30px;
  }
</style>
